'use client';

var translations = {
    'Job Title': 'Chức danh',
    Phone: 'Điện thoại',
    'Cover letter': 'Thư giới thiệu',
    Optional: 'Không bắt buộc',
    'Enter job title': 'Nhập chức danh',
    'Enter phone number': 'Nhập số điện thoại',
    'Enter cover letter': 'Nhập thư giới thiệu',
    'View sample': 'Xem mẫu thư giới thiệu',
    'Choose a profile to apply': 'Chọn hồ sơ ứng tuyển',
    'Please upload your attached CV to apply': 'Vui lòng đính kèm CV của bạn để ứng tuyển',
    'Upload your attached CV to apply': 'Đính kèm CV của bạn để ứng tuyển',
    'Employers prefer to receive your resume in': 'Nhà tuyển dụng ưu tiên hồ sơ ứng tuyển viết bằng',
    'Allow Employers to search': 'Cho phép Nhà tuyển dụng tìm kiếm',
    'VietnamWorks profile': 'Hồ sơ VietnamWorks',
    'Profile online': 'Hồ sơ trực tuyến',
    'Attached resume': 'Hồ sơ đính kèm',
    'Completed:': 'Hoàn thiện:',
    'Create attracted CV with WowCV': 'Tạo hồ sơ ấn tượng với WowCV',
    'This field is required.': 'Vui lòng nhập thông tin.',
    'Please do not enter numbers or special characters.': 'Vui lòng không nhập số hoặc kí tự đặc biệt.',
    'Please do not enter phone number or email.': 'Vui lòng không nhập số điện thoại hoặc email',
    'Please do not enter special characters.': 'Vui lòng không nhập kí tự đặc biệt.',
    'This is not a valid email address.': 'Địa chỉ email không hợp lệ.',
    'This is not a valid URL.': 'Đường dẫn không hợp lệ.',
    'This is not a valid number.': 'Số không hợp lệ.',
    'The phone number format is invalid.': 'Số điện thoại của bạn không hợp lệ.',
    'Attached CV': 'Hồ Sơ Đính Kèm',
    'CV Just Uploaded': 'Hồ Sơ Vừa Tải Lên',
    'Your searchable CV is disable now because of wrong contact information. Please contact with Vietnamworks to verify your information by email:': 'Hiện tại bạn không thể bật chức năng tìm kiếm hồ sơ vì nhập sai thông tin liên hệ. Vui lòng liên hệ với Vietnamworks để xác nhận lại thông tin qua email:',
    'Not enough information to use the function Allow Employers to search attached CV. Update information at': 'Chưa đủ thông tin để sử dụng chức năng Cho phép Nhà tuyển dụng tìm kiếm hồ sơ đính kèm. Cập nhật thông tin tại',
    'Profile settings': 'Thiết lập hồ sơ',
    'my-profile': 'ho-so',
    'profile-settings': 'thiet-lap-ho-so',
    'my-career-center': 'quan-ly-nghe-nghiep',
    'Updated:': 'Đã cập nhật:',
    'Uploaded:': 'Đã tải lên:',
    'Uploaded on:': 'Đã tải lên:',
    Update: 'Cập nhật',
    'Update profile': 'Cập nhật',
    'VietnamWorks online Profile': 'Hồ sơ online VietnamWorks',
    Resume: 'Resume',
    View: 'Xem',
    'View CV': 'Xem hồ sơ',
    Any: 'Bất kỳ',
    completed: 'hoàn thiện',
    'By Vietnamworks profile': 'Bằng hồ sơ Vietnamworks',
    'By attached CVs': 'Bằng hồ sơ đính kèm',
    Cancel: 'Huỷ',
    'Just uploaded': 'Vừa tải lên',
    'Job applied': 'Đã ứng tuyển',
    'Not approved': 'Chưa được duyệt',
    'preview-resume/': 'xem-truoc-ho-so/',
    'View as employer': 'Xem như nhà tuyển dụng',
    'Apply job': 'Ứng tuyển công việc',
    'View resume': 'Xem hồ sơ',
    'Delete resume': 'Xóa cv',
    'Expected Location': 'Nơi làm việc mong muốn',
    'Expected Function': 'Ngành nghề',
    'Expected Job Function': 'Ngành nghề',
    'Expected Industry': 'Lĩnh vực',
    'Expected Job Level': 'Cấp bậc mong muốn',
    'Expected Salary (USD per month)': 'Mức lương mong muốn (USD / tháng)',
    'Expected Salary': 'Mức lương mong muốn',
    'USD/month': 'USD/tháng',
    'Expected Top 5 Benefits': '5 Phúc Lợi Mong Muốn Nhất',
    'Please select...': 'Vui lòng chọn...',
    'First Name': 'Tên',
    'Last Name': 'Họ',
    'Enter your job title': 'Nhập chức danh của bạn',
    'Enter your first name': 'Nhập tên của bạn',
    'Enter your last name': 'Nhập họ của bạn',
    'Enter your address': 'Nhập địa chỉ của bạn',
    'Enter your current salary': 'Nhập mức lương hiện tại',
    'Enter your expected salary': 'Nhập mức lương mong muốn',
    'Enter your year experience': 'Nhập số năm kinh nghiệm',
    'No Result Found': 'Không Có Kết Quả Nào',
    'Years of experience': 'Số năm kinh nghiệm',
    Years: 'Năm',
    Search: 'Tìm',
    Year: 'Năm',
    'Current Job Level': 'Cấp bậc hiện tại',
    'Current Job Function': 'Ngành nghề hiện tại',
    'Current Industry': 'Lĩnh vực hiện tại',
    'Current Salary': 'Mức lương hiện tại',
    'Highest Education': 'Bằng cấp cao nhất',
    'Cell Number': 'Điện thoại',
    'Date of Birth': 'Ngày sinh',
    Nationality: 'Quốc tịch',
    'Marital Status': 'Tình trạng hôn nhân',
    'Country/ City/ District': 'Quốc gia/ Tỉnh thành/ Quận huyện',
    'Select your location': 'Chọn địa điểm của bạn',
    Location: 'Địa điểm',
    Address: 'Địa chỉ',
    Gender: 'Giới tính',
    'Select job function': 'Chọn ngành nghề',
    'You have selected the maximum number of benefits! Remove one to add another.': 'Bạn đã chọn tối đa số lượng phúc lợi! Xóa bớt để có thể chọn thêm.',
    'You have selected up to three locations': 'Bạn đã chọn tối đa ba nơi làm việc',
    'Your resume': 'Hồ sơ của bạn',
    'Working preference': 'Công việc mong muốn',
    'I agree to the': 'Tôi đồng ý với',
    'Privacy Policy': 'Quy định bảo mật',
    'of this employer.': 'của nhà tuyển dụng này.',
    'Please tick the checkbox if you want to proceed.': 'Vui lòng đánh dấu vào hộp chọn để tiếp tục nộp đơn.',
    'Application information': 'Thông tin ứng tuyển',
    Male: 'Nam',
    Female: 'Nữ',
    Single: 'Độc thân',
    Married: 'Đã kết hôn',
    'Apply now': 'Ứng tuyển',
    'Application confirmation': 'Xác nhận ứng tuyển',
    'Your current job level': 'Cấp bậc hiện tại của bạn',
    'is not matching to this job requirement': 'chưa phù hợp với yêu cầu công việc này',
    'Do you want to continue to apply?': 'Bạn có muốn tiếp tục nộp đơn?',
    '/success-apply': '/ung-tuyen-thanh-cong',
    '/my-profile': '/ho-so',
    'Please select an attachment to apply': 'Vui lòng chọn hồ sơ ứng tuyển',
    'Choose benefit': 'Chọn phúc lợi',
    '5 Expected Benefits': '5 phúc lợi mong muốn',
    'Enter salary': 'Nhập mức lương',
    Close: 'Đóng',
    'Accept invitation': 'Chấp nhận lời mời',
    Delete: 'Xoá',
    'Delete the attached CV': 'Xóa tập tin đính kèm',
    'Are you sure to delete it?': 'Bạn chắc chắn muốn xóa CV?',
    'The attached CV “{0}” will be deleted from our system.': 'CV đính kèm "{0}" sẽ được xóa khỏi hệ thống.',
    Success: 'Thành công',
    'Delete CV successfully': 'Xóa CV thành công',
    Searchable: 'Cho phép tìm kiếm',
    'Your CV is not able to process, please try another file.': 'Rất tiếc chúng tôi không thể xử lý CV của bạn, vui lòng chọn CV khác.',
    'We cannot process this file. Please ensure that the selected file contains the content of a CV and does not include too many images.': 'Chúng tôi không thể xử lý hồ sơ này. Hãy đảm bảo hồ sơ được chọn có chứa nội dung của một CV và không chứa quá nhiều hình ảnh.',
    'preview-resume': 'xem-truoc-ho-so'
};

export { translations as default };
//# sourceMappingURL=translations.js.map
